export {
    commonProps
}

let dimensionProps = dealProps([
    {prop: "dt", fixed: true, label: "Time", 'min-width': 120},
    {prop: "media_id", fixed: true, label: "媒体(Media)", 'min-width': 200},
    {prop: "ad_zone_id", fixed: true, label: "广告位(Ad Slot)", 'min-width': 150},
    {prop: "platform_id", label: "操作系统(OS)", sortable: false, 'min-width': 120},
    {prop: "ad_resource_type", fixed: true, label: "广告位样式(Ad Slot Type)", 'min-width': 190},
    {
        prop: "imp_ad_cnt",
        label: "广告请求量(Request Count)",
        sortable: true,
        'min-width': 200,
        formatter: numberFormatter
    },
    {
        prop: "bid_ad_cnt",
        label: "广告返回量(Return Count)",
        sortable: true,
        'min-width': 190,
        formatter: numberFormatter
    },
    {prop: "ad_delivery_ratio", label: "填充率(Fill Rate)", sortable: true, 'min-width': 130, formatter: percentFormatter},
    {
        prop: "charged_impression_cnt",
        label: "曝光量(Exposure Count)",
        sortable: true,
        'min-width': 190,
        formatter: numberFormatter
    },
    {
        prop: "imp_ratio",
        label: "曝光率(Exposure Through Rate)",
        sortable: true,
        'min-width': 240,
        formatter: percentFormatter
    },
    {
        prop: "charged_click_cnt",
        label: "点击量(Click Count)",
        sortable: true,
        'min-width': 150,
        formatter: numberFormatter
    },
    {prop: "click_ratio", label: "点击率(Click Through Rate)", sortable: true, 'min-width': 210, formatter: percentFormatter},
    {prop: "cost_estimate", label: "收入(Income)", sortable: true, 'min-width': 210, formatter: floatFormatter},
    {prop: "cost_estimate_ecpm", label: "eCPM", sortable: true, 'min-width': 230, formatter: floatFormatter},
]);

function numberFormatter(row, column, cellValue) {
    if (cellValue == null || cellValue === 'NaN' || cellValue === 'Infinity') {
        return '-'
    }
    const num = parseInt(cellValue)
    if (isNaN(num)) return '-'
    return num.toLocaleString('en-US')
}

function floatFormatter(row, column, cellValue) {
    if (cellValue == null || cellValue === 'NaN' || cellValue === 'Infinity') {
        return '-'
    }
    const num = parseFloat(cellValue)
    if (isNaN(num)) return '-'
    return num.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    })
}

function percentFormatter(row, column, cellValue) {
    if (cellValue == null || cellValue === 'NaN' || cellValue === 'Infinity') {
        return '-'
    }
    const num = Number(cellValue)
    if (isNaN(num)) return '-'
    return (num * 100).toFixed(2) + '%'
}

function dealProps(props) {
    for (let cfg of props) {
        cfg.resizable = true;
        cfg.sortable = false
        cfg.fixed = false
    }
    return props;
}

let commonProps = dimensionProps
